module.exports = __webpack_public_path__ + "img/32.ad9be300.svg";